// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2gI7l","footer":"ModalError_footer__1RhjC"};